import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=75705b2e&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"
import style0 from "./list2.vue?vue&type=style&index=0&id=75705b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75705b2e",
  null
  
)

export default component.exports